import React, { Component } from 'react';
import { toast } from 'react-toastify';
import Table from '../../Table/Table';
import {
    fetchUrl,
    getMerchants as fetchMerchants
} from '../merchantManagementActions';
import {
    getCount,
    getIsEditMerchantSuccessful,
    getIsMerchantsLoading,
    getPages,
    getMerchants,
    getMerchantsErrorMessage,
    getEditMerchantErrorMessage,
    getIsEditMerchantLoading,
    getIsMerchantsLoaded
} from '../merchantManagementEntity';
import ListItem from './ListItem/ListItem';
import { connect } from 'react-redux';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import MerchantEnabledCheckbox from './MerchantEnabledCheckbox';
import _ from 'lodash';

export class Merchants extends Component {
    static propTypes = {
        isEditMerchantSuccessful: PropTypes.bool,
        isMerchantsLoaded: PropTypes.bool,
        editMerchantError: PropTypes.string,
        isEditMerchantLoading: PropTypes.bool,
        merchants: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.renderHeaderComponent = this.renderHeaderComponent.bind(this);
        this.refetchData = this.refetchData.bind(this);
        this.resetNeedsRefetch = this.resetNeedsRefetch.bind(this);

        this.state = {
            needsRefetch: false
        };

        this.defaultColumnsAndProps = [
            {
                accessor: 'merchantId',
                defaultSortDesc: true,
                label: 'Merchant ID',
                minWidth: 145,
                show: true,
                sortable: true
            },
            {
                accessor: 'name',
                Cell: (props) => (this.getMerchantName(props.original.merchantId)),
                label: 'Name',
                minWidth: 150,
                show: true,
                sortable: true
            },
            {
                accessor: 'enabled',
                Cell: (props) => <MerchantEnabledCheckbox checked={props.value} merchantId={props.original.merchantId} />,
                className: ['center'],
                filterable: false,
                label: 'Enabled For Processing',
                minWidth: 130,
                show: true,
                sortable: false
            }
        ];
    }

    getMerchantName(originalMerchantId){
        const merchant = _.find(this.props.merchants, (n) => {
            return n.merchantId === originalMerchantId;
        });

        return _.get(merchant, 'merchantName') || '';
    }

    renderHeaderComponent() {
        return (
            <div className="header-container">
                <div className="header-text">
                    Merchant Accounts
                </div>
            </div>
        );
    }

    componentDidUpdate(previousProps) {
        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isEditMerchantSuccessful') && this.props.isEditMerchantSuccessful === true) {
            toast('Merchant updated successfully!', { type: 'success' });
            this.refetchData();
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'editMerchantError')) {
            toast(this.props.editMerchantError, { type: 'error' });
        }
    }

    resetNeedsRefetch() {
        this.setState({ needsRefetch: false });
    }

    refetchData() {
        this.setState({ needsRefetch: true });
    }

    render() {
        const shouldShowLoader = this.props.isEditMerchantLoading || !this.props.isMerchantsLoaded;

        return (
            <Table
                fetchUrl={fetchUrl}
                className="emvio-merchants-table"
                defaultColumnsAndProps={this.defaultColumnsAndProps}
                filterable={true}
                fetchData={fetchMerchants}
                countSelector={getCount}
                dataSelector={getMerchants}
                errorMessageSelector={getMerchantsErrorMessage}
                isActionLoading={shouldShowLoader}
                isDataLoadingSelector={getIsMerchantsLoading}
                pagesSelector={getPages}
                HeaderComponent={this.renderHeaderComponent}
                itemKey="merchantId"
                ListItemComponent={ListItem}
                needsRefetch={this.state.needsRefetch}
                noDataText="No Merchants Found"
                resetNeedsRefetch={this.resetNeedsRefetch}
                shouldUseAllMerchants
                shouldHideCardPadding
                shouldHideDateRange
                shouldHideExport
                uniqueTableName="Merchants"
                hidePageSizeSelect
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        isEditMerchantSuccessful: getIsEditMerchantSuccessful(state),
        editMerchantError: getEditMerchantErrorMessage(state),
        isEditMerchantLoading: getIsEditMerchantLoading(state),
        isMerchantsLoaded: getIsMerchantsLoaded(state),
        merchants: getMerchants(state)
    };
}

export default connect(mapStateToProps)(Merchants);
